<template>
  <teleport to="body">
    <div class="sticky-bar" v-if="data.dynamic_display">
      <a class="nav-link previous" v-if="data.navigation.previous" :href="data.navigation.previous.url" :title="data.navigation.previous.title">
        <span class="nav-link-label">{{ data.navigation.previous.title }}</span>
      </a>
      <button type="button" class="btn-dynamic" @click="toggleShow">
        <i class="icon-stripe" aria-hidden="true"></i>
        <i class="icon-stripe" aria-hidden="true"></i>
        <span class="icon-dynamic-wrapper">
          <svg class="icon-dynamic" aria-hidden="true" width="18" height="19" viewBox="0 0 18 19" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.5833 8.58594L15.25 6.91927L10 8.0026V2.33594H8.33333V7.46094L2.54167 3.71094L1.625 5.1276L7.95833 9.21094L3.08333 15.5859L4.41667 16.5859L9.125 10.4193L12.625 15.7109L14.0417 14.7943L10.5417 9.58594L15.5833 8.58594Z"
              fill="#CFD8DC" />
            <path
              d="M9.16667 11.9193C10.7775 11.9193 12.0833 10.6134 12.0833 9.0026C12.0833 7.39177 10.7775 6.08594 9.16667 6.08594C7.55584 6.08594 6.25 7.39177 6.25 9.0026C6.25 10.6134 7.55584 11.9193 9.16667 11.9193Z"
              fill="#296FF6" />
            <path
              d="M9.16537 4.41667C10.316 4.41667 11.2487 3.48393 11.2487 2.33333C11.2487 1.18274 10.316 0.25 9.16537 0.25C8.01477 0.25 7.08203 1.18274 7.08203 2.33333C7.08203 3.48393 8.01477 4.41667 9.16537 4.41667Z"
              fill="#FBC531" />
            <path
              d="M15.4154 9.83073C16.566 9.83073 17.4987 8.89799 17.4987 7.7474C17.4987 6.5968 16.566 5.66406 15.4154 5.66406C14.2648 5.66406 13.332 6.5968 13.332 7.7474C13.332 8.89799 14.2648 9.83073 15.4154 9.83073Z"
              fill="#FBC531" />
            <path
              d="M2.08333 6.5026C3.23393 6.5026 4.16667 5.56986 4.16667 4.41927C4.16667 3.26868 3.23393 2.33594 2.08333 2.33594C0.93274 2.33594 0 3.26868 0 4.41927C0 5.56986 0.93274 6.5026 2.08333 6.5026Z"
              fill="#FBC531" />
            <path
              d="M3.7513 18.1667C4.9019 18.1667 5.83464 17.2339 5.83464 16.0833C5.83464 14.9327 4.9019 14 3.7513 14C2.60071 14 1.66797 14.9327 1.66797 16.0833C1.66797 17.2339 2.60071 18.1667 3.7513 18.1667Z"
              fill="#FBC531" />
            <path
              d="M13.3333 17.3307C14.4839 17.3307 15.4167 16.398 15.4167 15.2474C15.4167 14.0968 14.4839 13.1641 13.3333 13.1641C12.1827 13.1641 11.25 14.0968 11.25 15.2474C11.25 16.398 12.1827 17.3307 13.3333 17.3307Z"
              fill="#FBC531" />
          </svg>
          <span class="icon-dynamic-label">{{ EtrTranslate.pageRubrique.button_floating_bar }}</span>
        </span>
      </button>
      <a class="nav-link next" v-if="data.navigation.next" :href="data.navigation.next.url" :title="data.navigation.next.title">
        <span class="nav-link-label">{{ data.navigation.next.title }}</span>
      </a>
    </div>
  </teleport>
  <DynamicView ref="refDynamicView" :nid="nid" :tree-data="treeData" :show="show" @close="toggleShow" />
</template>

<script>
import { ref } from 'vue';
import { EtrTranslate } from '@/services';
import DynamicView from '@/components/periple/dynamicView.component.vue';

export default {
  props: {
    nid: {
      type: String,
      default: null,
    },
    data: {
      type: Object,
      default: () => { /* empty as default */ },
    },
    treeData: {
      type: Object,
      default: () => { /* empty as default */ },
    },
  },
  components: {
    DynamicView,
  },
  setup() {
    const show = ref(false);
    const refDynamicView = ref(null);

    const toggleShow = () => {
      show.value = !show.value;
    };

    return {
      show,
      toggleShow,
      EtrTranslate,
      refDynamicView,
    };
  },
};
</script>
